import AchievementTrophyInfo from "../../components/game-views/datasets/achievement_trophy_info";

const getTrophyInfo =(type) => {       
        const medalObj = AchievementTrophyInfo.find(elem => elem.code === type);
        const imgSrc =  "./assets/Awards/" + medalObj.imgSrc;
        const medalType = medalObj.medalType;
        const medalImgObj = {imgSrc: imgSrc, medalType: medalType, medalNbr: medalObj.medalType};
        return (medalImgObj);
    }
export default getTrophyInfo;